export enum QualificationLevelIdentifiers {
  ALevel = 1,
  Gce = 2,
  OLevel = 3,
  IGCSE = 4,
  ASLevel = 5,
  Gcse = 6,
  Ial = 11,
  PrimaryCheckpoint = 22,
  CambridgeSecondary1 = 23,
  IAS_LEVEL = 24,
  PDQ = 25,
}
